// extracted by mini-css-extract-plugin
export default {"echarts_wrapper":"EnergyConsumptionTrends_echarts_wrapper__p3913"};